import React from "react";
import MockupPanel from "../components/MockupPanel";
import EmbeddedNav from "../components/EmbeddedNav";
import Accordion from "../components/ui/Accordion";

function SmallIcon({ type }) {
  const cls = "w-5 h-5 text-slate-600";
  if (type === "mail") {
    return (
      <svg className={cls} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 6h16v12H4V6z" stroke="currentColor" strokeWidth="2" />
        <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }

  if (type === "phone") {
    return (
      <svg className={cls} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M6 3h4l2 6-3 2c1.5 3 4 5.5 7 7l2-3 6 2v4c0 1-1 2-2 2C10 24 0 14 0 2c0-1 1-2 2-2h4z"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    );
  }

  if (type === "shield") {
    return (
      <svg className="w-4 h-4 text-slate-500" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V7l8-4z" stroke="currentColor" strokeWidth="2" />
      </svg>
    );
  }

  if (type === "clock") {
    return (
      <svg className="w-4 h-4 text-slate-500" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 8v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10z" stroke="currentColor" strokeWidth="2" />
      </svg>
    );
  }

  if (type === "card") {
    return (
      <svg className="w-4 h-4 text-slate-500" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
        <path d="M3 10h18" stroke="currentColor" strokeWidth="2" />
      </svg>
    );
  }

  return (
    <svg className={cls} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 8v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function TrustItem({ label, icon }) {
  return (
    <div className="flex items-center gap-2 text-sm text-slate-600">
      <SmallIcon type={icon} />
      <span>{label}</span>
    </div>
  );
}

const glassCard =
  "rounded-[22px] bg-white/25 backdrop-blur-lg border border-white/70 shadow-[0_14px_38px_rgba(15,23,42,0.08)]";

const faqItems = [
  {
    id: "review-time",
    question: "How long does review take?",
    answer: "1 to 48 hours.",
  },
  {
    id: "documents",
    question: "What documents do I need?",
    answer: "ID, proof of residence, 3 months bank statement, and latest payslip.",
  },
  {
    id: "repayment-method",
    question: "How do I repay?",
    answer: "Repay via debit orders.",
  },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#f6eef4]">
      <div className="w-full">
        <MockupPanel className="min-h-screen rounded-none border-0 shadow-none">
          <div className="px-6 md:px-10 pt-7 md:pt-8 pb-10 md:pb-12">
            <EmbeddedNav />

            <div className="mt-10 md:mt-12 text-center">
              <h1 className="text-[42px] md:text-[60px] leading-tight font-bold tracking-tight text-slate-900">
                Contact Us
              </h1>
              <p className="mt-2 text-lg md:text-[20px] text-slate-600">We&apos;re here to help.</p>
            </div>

            <div className="mt-8 md:mt-9 grid md:grid-cols-3 gap-5 md:gap-6">
              <article className={glassCard + " p-6"}>
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-2xl bg-white/45 border border-white/70 flex items-center justify-center">
                    <SmallIcon type="mail" />
                  </div>
                  <h2 className="text-2xl md:text-[30px] leading-none font-semibold text-slate-900">Email</h2>
                </div>
                <p className="mt-4 inline-flex rounded-xl bg-white/45 border border-white/70 px-4 py-2 text-sm text-slate-700">
                  admin@zebramicrowealth.co.za
                </p>
              </article>

              <article className={glassCard + " p-6"}>
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-2xl bg-white/45 border border-white/70 flex items-center justify-center">
                    <SmallIcon type="phone" />
                  </div>
                  <h2 className="text-2xl md:text-[30px] leading-none font-semibold text-slate-900">WhatsApp</h2>
                </div>
                <p className="mt-4 inline-flex rounded-xl bg-white/45 border border-white/70 px-4 py-2 text-sm text-slate-700">
                  0660297275
                </p>
              </article>

              <article className={glassCard + " p-6"}>
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-2xl bg-white/45 border border-white/70 flex items-center justify-center">
                    <SmallIcon type="clock" />
                  </div>
                  <h2 className="text-2xl md:text-[30px] leading-none font-semibold text-slate-900">Hours</h2>
                </div>
                <p className="mt-4 text-sm text-slate-700">
                  Mon-Fri &nbsp; <span className="font-semibold text-slate-900">8:00–17:00</span>
                </p>
              </article>
            </div>

            <div className="mt-7 flex flex-wrap justify-center gap-7">
              <TrustItem label="Secure application" icon="shield" />
              <TrustItem label="Privacy-first" icon="clock" />
              <TrustItem label="Transparent estimates" icon="card" />
            </div>

            <div className="mt-7 flex justify-center">
              <a
                href="https://5577-8888.webfin.co.za/webloans/"
                className="inline-flex items-center justify-center rounded-xl px-14 py-3.5 text-sm font-semibold text-white
                           bg-gradient-to-r from-pink-400 to-pink-600
                           shadow-[0_16px_40px_rgba(236,72,153,0.35)]
                           hover:brightness-105 transition"
              >
                Apply Now
              </a>
            </div>

            <div className="mt-12 md:mt-14 grid lg:grid-cols-[1.05fr_0.95fr] gap-8 md:gap-10 items-start">
              <div>
                <h2 className="text-4xl md:text-6xl font-bold tracking-tight text-slate-900">FAQs</h2>
                <p className="mt-2 text-lg md:text-[20px] text-slate-600">Have questions? We&apos;re here to help.</p>

                <div className={glassCard + " mt-7 p-7 min-h-[460px]"}>
                  <h3 className="text-[36px] leading-none font-semibold text-slate-900">FAQs</h3>
                  <p className="mt-2 text-sm text-slate-600">Have questions? We&apos;re here to help.</p>

                  <div className="mt-5">
                    <Accordion items={faqItems} />
                  </div>
                </div>
              </div>

              <div className={glassCard + " p-7 min-h-[540px]"}>
                <h3 className="text-[44px] leading-none font-semibold text-slate-900">Contact Form</h3>

                <form className="mt-5 space-y-3">
                  {[
                    { id: "fullName", label: "Full Name", type: "text" },
                    { id: "email", label: "Email Address", type: "email" },
                    { id: "phone", label: "Phone Number", type: "tel" },
                  ].map((f) => (
                    <div key={f.id}>
                      <label htmlFor={f.id} className="sr-only">
                        {f.label}
                      </label>
                      <input
                        id={f.id}
                        type={f.type}
                        placeholder={f.label}
                        className="w-full rounded-2xl bg-white/45 border border-white/70 px-4 py-3 text-sm text-slate-700 placeholder-slate-500 outline-none focus:ring-4 focus:ring-pink-200/45"
                      />
                    </div>
                  ))}

                  <div>
                    <label htmlFor="message" className="sr-only">
                      Message
                    </label>
                    <textarea
                      id="message"
                      placeholder="Message"
                      className="w-full min-h-[140px] rounded-2xl bg-white/45 border border-white/70 px-4 py-3 text-sm text-slate-700 placeholder-slate-500 outline-none focus:ring-4 focus:ring-pink-200/45"
                    />
                  </div>

                  <label className="flex items-center gap-2 text-sm text-slate-600">
                    <input type="checkbox" className="h-4 w-4 rounded border-slate-300" />
                    I agree to be contacted
                  </label>

                  <button
                    type="button"
                    className="mt-2 w-full rounded-xl px-6 py-3.5 text-sm font-semibold text-white
                               bg-gradient-to-r from-pink-400 to-pink-600
                               shadow-[0_16px_40px_rgba(236,72,153,0.35)]
                               hover:brightness-105 transition"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>

            <p className="mt-10 text-center text-[11px] text-slate-500 leading-relaxed">
              Zebra MicroWealth offers secure and responsible lending solutions.
              <br />
              Copyright © 2022 Zebra MicroWealth. All rights reserved.
              <br />
              Privacy Policy &nbsp;|&nbsp; Terms of Service
            </p>

            <div className="mt-8 text-center text-sm text-slate-600">
              Zebra MicroWealth offers secure and responsible lending solutions in South Africa.
            </div>
            <div className="mt-2 text-center text-xs text-slate-500">
              Copyright © 2022 Zebra MicroWealth. All rights reserved | Privacy Policy | Terms of Service
            </div>
          </div>
        </MockupPanel>
      </div>
    </div>
  );
}
